import { render, staticRenderFns } from "./AttractionInitiative.vue?vue&type=template&id=0e107a27&scoped=true&"
import script from "./AttractionInitiative.vue?vue&type=script&lang=ts&"
export * from "./AttractionInitiative.vue?vue&type=script&lang=ts&"
import style0 from "./AttractionInitiative.vue?vue&type=style&index=0&id=0e107a27&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e107a27",
  null
  
)

export default component.exports